exports = module.exports = require(33);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require(35);
exports.Duplex = require(31);
exports.Transform = require(34);
exports.PassThrough = require(32);
